import _ from 'lodash';

import cleanUpResponse from '@/util/cleanUpResponse';

export default async function GetAllCustomerOrderFormDataByOrderId(orderId) {
  const response = await $.soap({
    body: {
      GetAllCustomerOrderFormDataByOrderId: {
        $xmlns: 'http://dla.mil/ems/bpm/order/order_form',
        OrderId: orderId
      }
    },
    blueprintArrays: ['GetAllCustomerOrderFormDataByOrderIdResponse.FormData.CustomerOrderFormData'],
    blueprint: {
      items: [
        '$..GetAllCustomerOrderFormDataByOrderIdResponse.FormData.CustomerOrderFormData',
        {
          id: '$..ID',
          orderId: '$..OrderID',
          orderLineItemId: '$..OrderLineItemID',
          mfdOrderLineItemId: '$..MFDOrderLineItemID',
          quantity: '$..Quantity',
          price: '$..Price',
          clin: '$..CLIN',
          model: '$..Model',
          laserPrinterTonerCartridgeType: '$..LaserPrinterTonerCartridgeType',
          description: '$..Description',
          customDescription: '$..CustomDescription',
          configurationAndPricing: '$..ConfigurationAndPricing',
          volumeBand: '$..VolumeBand'
        }
      ]
    }
  });

  _.each(response.items, (item) => {
    item.formattedPrice = parseInt(item.price).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
  });

  cleanUpResponse(response);
  return response.items;
}
